import type { ReactElement } from "react";
import { Badge, type BadgeProps } from "../Badge";

export function StickerBadge<RC extends ReactElement | undefined = undefined>({
  rc,
  ...props
}: BadgeProps<RC>) {
  return <Badge {...props} rc={rc} />;
}
